import { z } from "zod";
import { CarryInBaseSchema } from "../generated/CarryIn";
import { GroupBaseSchema } from "../generated/Group";
import { LotBaseSchema } from "../generated/Lot";
import { MaterialBaseSchema } from "../generated/Material";
import { WorkBaseSchema } from "../generated/Work";
import { getUserSchema } from "./user";

export const CarryInWithUserSchema = CarryInBaseSchema.base.extend({
  User: getUserSchema.strip(),
});
export type carryInWithUser = z.infer<typeof CarryInWithUserSchema>;

export const carryInRowSchema = CarryInWithUserSchema.extend({
  // 工事は Work。Work は担当者を持たないため User ネストは無い。work_id が null なら null 相当。
  Work: WorkBaseSchema.base.nullable(),
  Materials: z.array(
    MaterialBaseSchema.base.extend({
      Lot: LotBaseSchema.base.nullable().optional(),
    }),
  ),
});
export const carryInRowsSchama = z.array(carryInRowSchema);

export type carryInRow = z.infer<typeof carryInRowSchema>;
export type carryInRows = z.infer<typeof carryInRowsSchama>;

// 搬入の正規化応答(重複排除)。従来の Materials(Lot込み)・Work(工事)・User ネストを
// related バケットへ分離し、ネスト形(carryInRow)への復元は web 側 util/hydrators/carryInHydrator が行う。
// キー名は IndexedDB の SetCache 収集キー(PascalCase 複数形)に合わせてある。
// related.Lots / related.Works には従来 include の where(deleted_at: null)を踏襲して
// alive の行のみ入る(材料検索の履歴解決とは方針が異なるが、本ルートの現行仕様として維持する)。
// 単一取得(get-carry-in-from-id)も同形(CarryIns 配列に1件)で返し、応答組み立てを一覧取得と共有する。
export const normalizedCarryInResponseSchema = z.object({
  CarryIns: CarryInBaseSchema.base.array(),
  related: z.object({
    Materials: MaterialBaseSchema.base.array(),
    Lots: LotBaseSchema.base.array(),
    Works: WorkBaseSchema.base.array(),
    // User 内の Group ネストも一般規則どおり分離する(Users は group_id 参照のみ)
    Users: getUserSchema.omit({ Group: true }).strip().array(),
    Groups: GroupBaseSchema.base.array(),
  }),
});
export type NormalizedCarryInResponse = z.infer<typeof normalizedCarryInResponseSchema>;

export const carryInWithUserAndMaterialSchema = CarryInWithUserSchema.extend({
  Materials: MaterialBaseSchema.rows,
});
export const carryInsWithUserAndMaterialSchema = carryInWithUserAndMaterialSchema.array();
export type carryInWithUserAndMaterial = z.infer<typeof carryInWithUserAndMaterialSchema>;
export type carryInsWithUserAndMaterial = z.infer<typeof carryInsWithUserAndMaterialSchema>;
